export default "__VITE_ASSET__u24YeBEa__"